import React from 'react';
import styles from './HQToast.module.css';

export default class HQToast extends React.Component {
    constructor(props) {
        super(props);
    };

	render() {
		const { message = '' } = this.props;

		if (message === null || message === undefined || message === '') {
			return null;
		}

		return (
			<div className={styles.toastOverlay} role="presentation">
				<div
					className={styles.toastCard}
					role="status"
					aria-live="polite"
					aria-atomic="true"
				>
					<div className={styles.toastLabel}>Message</div>
					<div className={styles.toastMessage}>{String(message)}</div>
				</div>
			</div>
		);
	};
}